import { IProps } from '@/Interfaces/Icons/Props.interface';
import classNames from 'classnames';

const TaskDaily = ({ className, ...props }: IProps) => {
  const iconClassName = classNames('task-daily-icon', className);

  return (
    <svg
      className={iconClassName}
      width='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.75 1.25043H3C2.58579 1.25043 2.25 1.58621 2.25 2.00043V22.0004C2.25 22.4146 2.58579 22.7504 3 22.7504L20 22.7504C20.1989 22.7504 20.3897 22.6714 20.5303 22.5308C20.671 22.3901 20.75 22.1993 20.75 22.0004V2.00043C20.75 1.58621 20.4142 1.25043 20 1.25043H16.25V4.75043C16.25 5.16464 15.9142 5.50043 15.5 5.50043H7.5C7.08579 5.50043 6.75 5.16464 6.75 4.75043V1.25043ZM16.5 11.7504H12.5V10.2504H16.5V11.7504ZM11.0294 9.53081L9.96875 8.47015L7.49908 10.9398L6.52941 9.97015L5.46875 11.0308L7.49908 13.0611L11.0294 9.53081ZM16.5 17.7504H12.5V16.2504H16.5V17.7504ZM7 18.0004H9V16.0004H7V18.0004Z'
        fill='currentColor'
      />
      <path d='M14.75 1.25043H8.25V4.00043H14.75V1.25043Z' fill='currentColor' />
    </svg>
  );
};

export default TaskDaily;
